export default {"src":"/_next/static/media/edit.a7ee87c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};